import { useLocation, Link } from 'react-router-dom';
import { useState, useEffect, useCallback } from 'react';

function Header() {
    const location = useLocation();
    const currentPath = location.pathname;
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [rollBack, setRollBack] = useState(null);

    const links = [
        {path: '/', text: 'Home'},
        {path: '/About', text: 'About'},
        {path: '/BATTLEDRIFT', text: 'BATTLEDRIFT', style: { fontFamily: 'Athabasca' }},
        {path: '/BATTLEDRIFT-DEMO', text: 'BATTLEDRIFT DEMO', style: { fontFamily: 'Athabasca' }}
    ];

    const toggleHorizontal = () => {
        const menu = document.getElementById('dragon-menu');
        if (menu) {
            menu.classList.remove('closing');
            const transforms = menu.querySelectorAll('.custom-can-transform');
            transforms.forEach(el => {
                el.classList.toggle('pure-menu-horizontal');
            });
        }
    };

    const toggleMenu = useCallback(() => {
        setIsMenuOpen(prev => {
            const newOpenState = !prev;
            
            if (newOpenState) {
                // Opening menu
                if (prev && rollBack) {
                    // If closing animation is in progress, clear it
                    clearTimeout(rollBack);
                    setRollBack(null);
                }
                toggleHorizontal();
            } else {
                // Closing menu
                const menu = document.getElementById('dragon-menu');
                if (menu && prev) {
                    menu.classList.add('closing');
                    const timeoutId = setTimeout(toggleHorizontal, 500);
                    setRollBack(timeoutId);
                }
            }
            
            return newOpenState;
        });
    }, [rollBack]);

    const closeMenu = useCallback(() => {
        if (isMenuOpen) {
            toggleMenu();
        }
    }, [isMenuOpen, toggleMenu]);

    useEffect(() => {
        const handleResize = () => {
            closeMenu();
        };

        window.addEventListener('resize', handleResize);
        window.addEventListener('orientationchange', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('orientationchange', handleResize);
            if (rollBack) {
                clearTimeout(rollBack);
            }
        };
    }, [closeMenu, rollBack]);

    return (
        <div className={`custom-wrapper ${isMenuOpen ? 'open' : ''}`} id="dragon-menu">
            <div className="custom-brand-section">
                <div className="pure-menu">
                    <Link to="/" className="pure-menu-heading custom-brand">
                        <img src="/DragonDuckLogoZoomOutline.svg" alt="Dragon Duck Games Logo" style={{ height: '5em', marginRight: '1em', verticalAlign: 'middle' }} />
                        <span style={{ fontFamily: 'Pretender', fontSize: '2.2em' }}>Dragon Duck Games</span>
                    </Link>
                </div>
            </div>
            <button 
                className={`custom-toggle ${isMenuOpen ? 'x' : ''}`} 
                id="toggle"
                onClick={toggleMenu}
                aria-label="Toggle menu"
            >
                <s className="bar"></s>
                <s className="bar"></s>
            </button>
            <div className="custom-menu-section">
                <div className="pure-menu pure-menu-horizontal custom-can-transform">
                    <ul className="pure-menu-list">
                        {links.map(li => (
                            <li
                                key={li.path}
                                className={'pure-menu-item ' + (currentPath === li.path ? 'pure-menu-selected' : '')}
                            >
                                <Link to={li.path} className='pure-menu-link' style={li.style ?? {}}>{li.text}</Link>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default Header;
